<template>
  <!-- 资质列表 -->
  <div>
    <div class="fourthStep">
      <div class="table_title">企业违法行为</div>
      <el-table
        ref="checkedTable"
        border
        :data="newTableData"
        class="ccui-form-child-table"
        max-height="99999"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50">
        </el-table-column>
        <template v-for="(table, index) in tableThead">
          <el-table-column
            :fixed="table.fixed || false"
            :key="index"
            :label="table.label"
            :align="table.align || 'left'"
            :header-align="table.headerAlign || 'left'"
            :width="table.width"
            :min-width="table.minWidth"
            :prop="table.prop"
            :formatter="formatterList[table.formatterName]"
            :show-overflow-tooltip="true"
            :border="true"
          >
          </el-table-column>
        </template>  
      </el-table>
      <div class="ccui-table-footer">
        <div id="ccui-paging">
          <el-pagination
            :total="page.total"
            :current-page.sync="page.pageNo"
            :page-size="page.pageSize"
            prev-text="< 上一页"
            next-text="下一页 >"
            background
            layout=" prev, pager, next, jumper"
            popper-class="ccui-paging-page-size-popper"
            @current-change="handleCurrentChange"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: []
    },
  },
  components: {
  },
  computed: {
    pickerOptions() {
      return {
        disabledDate: function(time) {
          return false;
        }
      };
    },
  },
  data() {
    return {
      tableThead: [{
        label: "列入日期",
        prop: "putDate",
        width: "120",
        align: "left",
      },{
        label: "列入决定机关",
        prop: "putDepartment",
        minWidth: "120",
        align: "left",
      },{
        label: "列入严重违法失信企业名单原因",
        prop: "putReason",
        minWidth: "240",
        align: "left",
      },],
      formatterList: {},
      page: {
        total: 0,
        pageNo: 1,
        pageSize: 10,
      },
      newTableData: []
    };
  },
  created() {
    this.page.total = this.tableData.length;
    this.newTableData = this.tableData.slice(0,10)
  },
  methods: {
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.newTableData = this.tableData.filter((item, index ) => 
        index < this.page.pageNo * this.page.pageSize && index >= this.page.pageSize * (this.page.pageNo - 1)
      )
    },
  }
};
</script>

<style lang="scss" scoped>
.fourthStep {

}
.el-table /deep/th.gutter {

}
.table_title {
  width: 100%;
  line-height: 40px;
  border: 1px solid #EDF2FC;
  border-bottom: 0px;
  box-sizing: border-box;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  background-color: #f8fafd;
}
.add_button {
  display: block;
  width: 100%;
  height: 30px;
  margin-top: 20px;
  margin-bottom: 10px;
  /deep/ .el-button {
    float: right;
  }
}
/deep/ .el-table__body td{
  padding: 12px 0 !important;
}
.dialog_content {
  max-height: 600px;
  overflow: auto;
    /deep/ .el-table__body td{
      padding: 5px 0 !important;
    }
    /deep/ .el-table__header-wrapper th{
      padding: 5px 0 !important;
    }
}
/deep/ .el-dialog__body {
  max-height: unset !important;
}
#ccui-paging {
  margin-top: 10px;
}
/deep/ .el-searchs-right .el-input {
  margin-top: 5px;
}
</style>
